import React, {Component} from "react";
import PropTypes from 'prop-types';
import {Table, Button} from "reactstrap";
import {useSelector, useDispatch } from 'react-redux';
import {deleteStat, revertStatusStat} from "../../redux/statSlice";
import {openModalStat, openModal} from "../../redux/modalSlice";
import {globals} from "../Globals/Globals"
import Kpi from "../Kpi/Kpi";

const StatsRawTableDataSync = (props) =>{
    const dispatch = useDispatch();
    const {deleteStat_result} = useSelector((state) => state.stats)

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (deleteStat_result.status == "deleted"){
            try{
                dispatch(openModal({title:"Statistique supprimée"}));
            }
            finally{
                dispatch(revertStatusStat())
            }
        }

        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [deleteStat_result, dispatch]);

     /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} userItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.stat_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }
    

    const tableRendering = () => {
        let table_body = null;

        if (!((props.stat_list != null) && (props.stat_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucune statistique</td></tr>;
        }
        else{
            table_body = props.stat_list.map((statItem,i)=>{
                return  <tr key={statItem.data_guid} className="thumbnail">
                            <td id="table-item-container">
                                <div id="table-item">
                                        <Kpi
                                            icon_style={statItem?.data_blob?.data_tier?.icon_style || ""}
                                            title={statItem.data_blob.data_tier.stat_title}
                                            title_fontSize={"2rem"}
                                            color={statItem.data_blob.data_tier.stat_color}
                                            text={statItem.data_blob.data_tier.stat_sub_title}
                                            value={statItem.data_blob.data_tier.stat_value}
                                            unit={statItem.data_blob.data_tier.stat_unit}
                                        />
                                </div>
                                <div id="table-commands">
                                    {!props.read_only &&
                                        <div className="cmd_btn_delete">
                                            <Button onClick={()=>{handleManager(statItem.data_guid, (statObject)=>{
                                                dispatch(openModal(
                                                    {title:`Supprimer la statistique ${statObject.data_blob.data_tier.stat_title} ?`,
                                                     okCallBack:(DialogObject)=>{dispatch(deleteStat(statObject))}})) })}} 
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="cmd_btn_update">
                                            <Button onClick={()=>{handleManager(statItem.data_guid, (statObject)=>{dispatch(openModalStat({stat_data_guid:statObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});
                }

        return(
            <Table striped responsive={true}>
               <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    return (
        <>
            {tableRendering()}
        </>);
}

StatsRawTableDataSync.propTypes = { 
    table: PropTypes.bool,
};

StatsRawTableDataSync.defaultProps = {
    table:true,
};



export default StatsRawTableDataSync;
